import * as React from 'react';
import './WarrantyView.scss';
import Breadcrumbs from 'src/components/common/Breadcrumbs';
import i18n from 'src/translation/i18n';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { damagedPartsUrl, defectivePartsUrl } from 'src/utils/navigation';
import WarrantyClaim from '../WarrantyClaim/WarrantyClaim';
import ProductWarranty from '../ProductWarranty/ProductWarranty';
import DamagedView from '../DamagedView';
import { withI18n } from 'react-i18next';
import DifferentissueView from '../DifferentissueView/DifferentissueView';
import damageupon from '../../assets/damageupon';
import partfailed from '../../assets/partfailedIcon';
import scotmanClaimIcon from '../../assets/scotmanClaimIcon';
import issuewithorder from '../../assets/issuewithorderIcon';
import { makeStyles } from '@material-ui/core/styles';
import CSStatus from 'src/components/ClaimStatus/components/CSStatus/CSStatus';
import ClaimStatusModel from 'src/model/ClaimStatus.model';

import iObjCSService from 'src/services/claimStatus/claimStatusService';
import ClaimDetailsModel from 'src/model/ClaimDetails.model';
import ClaimPartDetails from 'src/model/ClaimPartDetails.model';
import env from 'src/shared/env';
interface IWarrantyProps {
  t?: any;
  // currentTab: number;
  // selectTab: (index: number) => void;
}

const WarrantyView: React.FC<IWarrantyProps> = props => {
  const [apiLoader, handleApiLoader] = React.useState(false);

  const {
    t
    // currentTab,
    // selectTab,
  } = props;
  const useStyles = makeStyles({
    label: {
      // backgroundColor: '#aa0',
      fontSize: '40px'
    },

    wcsLabel: {
      fontWeight: 'normal'
    }
  });
  const classes = useStyles();

  const [currentTab, setCurrentTab] = React.useState<number>(0);
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    if (cResubmitDetails || RSClaimDetails) {
      setActive(false);
      setThirdActive(false);
      setSecondActive(false);
      setcResubmitDetails(null);
      SetRSClaimDetails(null);
    }
  };
  const [active, setActive] = React.useState(false);
  const [secondactive, setSecondActive] = React.useState(false);
  const [thirdactive, setThirdActive] = React.useState(false);
  const [fourthactive, setFourthActive] = React.useState(false);
  const firstcard = () => {
    /* if(bStatus && bStatus===true){
      setcResubmitDetails(null);
      SetResubmitClaim(false);
    } */

    // debugger;
    if (
      !cResubmitDetails ||
      (cResubmitDetails &&
        cResubmitDetails.claimType.toLowerCase().substring(0, 5) === 'faile')
    ) {
      setSecondActive(false);
      setThirdActive(false);
      setFourthActive(false);
      setActive(true);
    }
  };
  const secondcard = () => {
    /* if(bStatus && bStatus===true){
      setcResubmitDetails(null);
      SetResubmitClaim(false);
    } */
    // debugger;
    if (
      !cResubmitDetails ||
      (cResubmitDetails &&
        cResubmitDetails.claimType.toLowerCase().substring(0, 5) === 'damag')
    ) {
      setActive(false);
      setThirdActive(false);
      setFourthActive(false);
      setSecondActive(true);
    }
  };
  const thirdcard = () => {
    if (cResubmitDetails === undefined) {
      setActive(false);
      setSecondActive(false);
      setFourthActive(false);
      setThirdActive(true);
    }
  };

  const fourthcard = () => {
    /* if(bStatus && bStatus===true){
      setcResubmitDetails(null);
      SetResubmitClaim(false);
    } */

    // debugger;

    if (
      !cResubmitDetails ||
      (cResubmitDetails &&
        cResubmitDetails.claimType.toLowerCase() === 'product warranty')
    ) {
      setActive(false);
      setSecondActive(false);
      setThirdActive(false);
      setFourthActive(true);
    }
  };

  const [reset, checkReset] = React.useState(false);
  const [cardActive, SetCardActiveStatus] = React.useState(false);

  const [IsRClaim, SetResubmitClaim] = React.useState(false);

  const [cResubmitDetails, setcResubmitDetails] = React.useState<
    ClaimPartDetails
  >();
  const [RSClaimDetails, SetRSClaimDetails] = React.useState<any>();
  function GetCSPDetails() {
    const activeAccount = localStorage.getItem('activeAccount');
    handleApiLoader(true);
    iObjCSService
      .getCSPartDetails(activeAccount, cResubmitDetails)
      .then((response: any) => {
        // console.log(response.data);
        const resData = response.data;
        if (cResubmitDetails.claimType.substring(0, 5) === 'Damag') {
          SetRSClaimDetails(resData);
        } else if (cResubmitDetails.claimType.substring(0, 5) === 'Faile') {
          SetRSClaimDetails(resData);
        }

        // console.log(RSClaimDetails);
        handleApiLoader(false);
      })
      .catch((error: any) => {
        // console.log(error);
        handleApiLoader(false);
        // removeColumnOrganiser();
      });
  }

  function GetCSPDetailsProductWarranty() {
    const activeAccount = localStorage.getItem('activeAccount');
    handleApiLoader(true);
    iObjCSService
      .getCSPartDetailsProductWarranty(activeAccount, cResubmitDetails)
      .then((response: any) => {
        // console.log(response.data);
        const resData = response.data;
       if (cResubmitDetails.claimType.toLowerCase() === 'product warranty') {
          SetRSClaimDetails(resData);
        }

        // console.log(RSClaimDetails);
        handleApiLoader(false);
      })
      .catch((error: any) => {
        // console.log(error);
        handleApiLoader(false);
        // removeColumnOrganiser();
      });
  }

  React.useEffect(() => {
    if (IsRClaim) {
       // console.log("============",cResubmitDetails);
      // debugger;
      if (
        cResubmitDetails &&
        cResubmitDetails.claimType.toLowerCase().substring(0, 5) === 'faile'
      ) {
        firstcard();
        GetCSPDetails();
      } else if (
        cResubmitDetails &&
        cResubmitDetails.claimType
          .toString()
          .toLowerCase()
          .substring(0, 5) === 'damag'
      ) {
        secondcard();
        GetCSPDetails();
      }else if(cResubmitDetails &&
        cResubmitDetails.claimType.toLowerCase() === 'product warranty'){
          fourthcard();
          // GetCSPDetails();
          GetCSPDetailsProductWarranty();
      }
      setValue(0);
      SetResubmitClaim(false);
    }
  }, [IsRClaim]);

  return (
    <div className="warranty-view">
      <h3>{i18n.t('warrantyView.myclaims')}</h3>
      <Tabs
        value={value}
        indicatorColor="primary"
        onChange={handleChange}
        aria-label="disabled tabs example"
        className={classes.label}
      >
        <Tab
          label={i18n.t('warrantyView.submitClaim')}
          style={{
            textTransform: 'none',
            fontFamily: 'Roboto',
            letterSpacing: 'inherit'
          }}
        />
        <Tab
          label={i18n.t('warrantyView.claimStatus')}
          style={{
            textTransform: 'none',
            fontFamily: 'Roboto',
            letterSpacing: 'inherit',
            marginLeft: '10px'
          }}
          className={classes.wcsLabel}
        />
      </Tabs>
      {apiLoader ? (
        <div className="loader-container">
          <div className="loader" />
        </div>
      ) : (
        <>
          {value === 0 && (
            <>
              <div className="tab-set-container">
                {!active || !secondactive || !thirdactive ? (
                  <p className="claim-type">
                    {i18n.t('warrantyView.selectissue')}
                  </p>
                ) : (
                  ''
                )}
                <div className="d-flex card-wrapper">
                  <div className="invoice-card-container">
                    <div className="tick-holder">
                      {' '}
                      {active === true ? (
                        <i className="rpds rpds-check-circle success " />
                      ) : (
                        ''
                      )}{' '}
                    </div>
                    <div
                      onClick={firstcard}
                      className={`d-flex card-appear ${
                        active === true ? 'border' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <img src={partfailed} alt="partfailed" />
                      </div>

                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('warrantyView.partfailed')}
                        </div>
                      </div>
                    </div>
                  </div>

                  { env.REACT_APP_BASE_ENVIRONMENT === 'US' &&      
                  <div className="invoice-card-container">
                    <div className="tick-holder">
                      {' '}
                      {fourthactive === true ? (
                        <i className="rpds rpds-check-circle success " />
                      ) : (
                        ''
                      )}{' '}
                    </div>
                    <div
                      onClick={fourthcard}
                      className={`d-flex card-appear ${
                        fourthactive === true ? 'border' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <img src={scotmanClaimIcon} alt="Product Warranty" />
                      </div>

                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('warrantyView.productWarranty1')}<br/>
                          {i18n.t('warrantyView.productWarranty2')}
                        </div>
                      </div>
                    </div>
                  </div>
                  }

                  <div className="invoice-card-container">
                    <div className="tick-holder">
                      {' '}
                      {secondactive === true ? (
                        <i className="rpds rpds-check-circle success " />
                      ) : (
                        ''
                      )}{' '}
                    </div>
                    <div
                      onClick={secondcard}
                      className={`d-flex card-appear ${
                        secondactive === true ? 'border' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <div className="img-bg3">
                          <img src={damageupon} alt="damageupon" />
                        </div>
                      </div>
                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('warrantyView.damageupon')}
                        </div>
                      </div>
                    </div>
                    {/* <div className="enhance-wrapper">
                {secondactive === true ? (
                  <p className="enhancs">(Enhancements Coming Soon!)</p>
                ) : (
                  ''
                )}
              </div> */}
                  </div>
                  <div className="invoice-card-container">
                    <div className="tick-holder">
                      {' '}
                      {thirdactive === true ? (
                        <i className="rpds rpds-check-circle success " />
                      ) : (
                        ''
                      )}{' '}
                    </div>
                    <div
                      onClick={thirdcard}
                      className={`d-flex card-appear ${
                        thirdactive === true ? 'border' : ''
                      }`}
                    >
                      <div className="icon-width">
                        <img src={issuewithorder} alt="issuewithorder" />
                      </div>

                      <div className="card-info">
                        <div className="total-balance">
                          {i18n.t('warrantyView.issuewithorder')}
                        </div>
                      </div>
                    </div>
                    {/* <div className="enhance-wrapper">
                {thirdactive === true ? (
                  <p className="enhancs">(Enhancements Coming Soon!)</p>
                ) : (
                  ''
                )}
              </div> */}
                  </div>
                </div>
                {active ? (
                  <WarrantyClaim
                    t={withI18n()}
                    cResubmitDetails={cResubmitDetails}
                    RSClaimDetails={RSClaimDetails}
                  />
                ): fourthactive ? (
                  <ProductWarranty 
                  t={withI18n()}
                  cResubmitDetails={cResubmitDetails}
                  RSClaimDetails={RSClaimDetails}
                  />
                ) : secondactive ? (
                  <DamagedView
                    cResubmitDetails={cResubmitDetails}
                    RSClaimDetails={RSClaimDetails}
                  />
                ) : thirdactive ? (
                  <DifferentissueView />
                ) : (
                  ''
                )}
              </div>
            </>
          )}
          {value === 1 && (
            <>
              <div className="tab-set-container">
                <CSStatus
                  checkReset={checkReset}
                  cResubmitDetails={cResubmitDetails}
                  setcResubmitDetails={setcResubmitDetails}
                  SetResubmitClaim={SetResubmitClaim}
                />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default WarrantyView;
